import { render, staticRenderFns } from "./document-reference-link.vue?vue&type=template&id=205cc53e&scoped=true&"
import script from "./document-reference-link.vue?vue&type=script&lang=js&"
export * from "./document-reference-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205cc53e",
  null
  
)

export default component.exports